import '../App.css';
import HeaderBar from '../HeaderObject.js';
import FooterBar from '../FooterObject.js';
import Banner from '../banner.js';
import CodeBlock from '../CodeBlock.js';
import DetailsWindow from '../DetailWindow.js';
import '../Diagonal.css'
import GameEmbed from '../GameEmbed.js';

import { Fade } from 'react-reveal';

export default function RasPage(){
    return(
        <div className='App'>
            <HeaderBar />
            <Banner 
                title={"Run 'a Store"}
                textCol={"#ff6b97"}
                image={"https://safebuckledev.github.io/img/run_banner2.PNG"}
            />

            <article>
                <GameEmbed 
                    projTitle={"Run 'a Store"}
                    embedLink={"https://safebuckledev.github.io/rasproject/index.html"}
                    gameWidth={"960"}
                    gameHeight={"500"}
                    cropHeight={"0"}
                />
            </article>

            <article >
                <Fade bottom distance="40%" duration={750}>
                    <h1 className='TitleText'>About the project</h1>
                </Fade>

                <DetailsWindow 
                    details={"Run 'a Store is a store simulation game that I developed together with two other developers and three artists over a period of eight weeks as part of a school project. In this project, I took on a leading role. In addition to programming, I was responsible for maintaining the Git repository, designing the system structure, and guiding the team when issues arose. My main focus was on developing the AI and its interactions with the various objects, the building system, and the camera. I also assisted with bug fixing whenever necessary."}
                    textWidth={'100vh'}
                    imgWidth={'0vh'}
                />
            </article>

            <article >
                <Fade bottom distance="40%" duration={750}>
                    <h1 className='TitleText'>Building System</h1>
                </Fade>

                <DetailsWindow 
                    details={"For the building system, I wanted to make it as easy to understand as possible. Each object falls into one of the following categories: floor, wall, or interactable. The objects are placed on a grid, with each cell referred to as a 'grid cell.' Each grid cell tracks which type of object is placed and its rotation. A cell can contain one floor object, four wall objects, and four interactable objects. This setup allows the player to easily create various shapes without the need for separate corner walls or constantly switching between different objects."}
                    image={"https://safebuckledev.github.io/img/ras/build.gif"}
                />

                <Fade bottom distance="40%" duration={750}>
                    <CodeBlock 
                        data={"public IEnumerator PlaceObject(ObjectTypes type, GameObject obj)\n    {\n        containers[(int)type].objects.Add(obj);\n\n        yield return new WaitForEndOfFrame();\n\n        surface.BuildNavMesh();\n    }"}
                    />
                </Fade>
            </article>

            <article>
                <Fade bottom distance="40%" duration={750}>
                    <h1 className='TitleText'>Brain Script</h1>
                </Fade>

                <DetailsWindow 
                    details={"For the AI, I wanted to make the system as flexible as possible. To achieve this, I created a brainscript that allows me to easily create and trigger various commands, enabling the AI to perform a wide range of tasks without the code becoming messy. The brainscript is similar to a regular script in terms of structure and functions: it includes start, update, and end functions, which are sufficient to smoothly handle all the functionality."}
                    image={"https://safebuckledev.github.io/img/ras/AI.gif"}
                />

                <Fade bottom distance="40%" duration={750}>
                    <CodeBlock 
                        data={"public interface ICustomerTask\n{\n    public void StartTask(CustomerBrain brain);\n    public void Execute(CustomerBrain brain);\n    public void EndTask(CustomerBrain brain);\n}"}
                    />
                </Fade>

                <Fade bottom distance="40%" duration={750}>
                    <CodeBlock 
                        data={"public class CustomerBrain : MonoBehaviour\n{\n    public ICustomerTask currentTask;\n\n    public CustomerType cType;\n\n    [HideInInspector] public NavMeshAgent agent;\n    [HideInInspector] public ObjectManager oManager;\n    [HideInInspector] public UIManager uiManager;\n\n    public List<int> products = new List<int>();\n\n    public void Start()\n    {\n        agent = GetComponent<NavMeshAgent>();\n        oManager = FindObjectOfType<ObjectManager>();\n        uiManager = FindObjectOfType<UIManager>();\n        oManager.Customers.Add(this.gameObject);\n        SetTask(new BuyItem());\n    }\n\n    public void SetTask(ICustomerTask task)\n    {\n        if (currentTask != null)\n        {\n            currentTask.EndTask(this);\n\n            currentTask = task;\n            currentTask.StartTask(this);\n        }\n        else\n        {\n            currentTask = task;\n            currentTask.StartTask(this);\n        }\n    }\n\n    public void Update()\n    {\n        currentTask.Execute(this);\n    }\n}"}
                    />
                </Fade>
            </article>

            <FooterBar />
        </div>
    );
}